import * as React from 'react';
import { ActionAfterViewed } from '@cian/action-after-viewed-component';
import { useSelector } from 'react-redux';

import { trackNewbuildingFromTheBuilderBlockAppearance, trackTransferToNewbuildingFromTheBuilder } from './tracking';
import { Newbuildings } from '../../components/Newbuildings';
import { NewbuildingsLink } from '../../components/Newbuildings/components/NewbuildingsLink';
import { getRegionId, getBuilderNewbuildings, getNewbuildingsFromBuilderLink } from '../../selectors/newbuilding';

export function BuilderNewbuildingsContainer() {
  const regionId = useSelector(getRegionId);
  const newbuildings = useSelector(getBuilderNewbuildings);
  const newbuildingsFromTheBuilderLink = useSelector(getNewbuildingsFromBuilderLink);

  const onAppear = React.useCallback(() => {
    trackNewbuildingFromTheBuilderBlockAppearance(newbuildings);
  }, [newbuildings]);

  const onNewbuildingClick = React.useCallback(
    (index: number) => {
      trackTransferToNewbuildingFromTheBuilder(newbuildings, index);
    },
    [newbuildings],
  );

  if (newbuildings.length === 0) {
    return null;
  }

  return (
    <ActionAfterViewed callback={onAppear}>
      <Newbuildings
        title="Жилые комплексы от застройщика"
        regionId={regionId}
        newbuildings={newbuildings}
        link={newbuildingsFromTheBuilderLink && <NewbuildingsLink url={newbuildingsFromTheBuilderLink} />}
        onNewbuildingClick={onNewbuildingClick}
      />
    </ActionAfterViewed>
  );
}
